import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, makeStyles, Modal } from '@material-ui/core';

import { useAuth, storeReferrer } from '@klpkonsern/auth-core';
import {
    customApiSelectors,
    setRemoteSessionExpired,
} from '@klp/core/api/store';
import { ActionButton, Block, Heading, Typography } from '@klp/design';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalContent: {
        width: theme.breakpoints.values.sm,
        backgroundColor: theme.palette.background.paper,
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(2),
    },
}));

export const SessionExpiryModal: React.FC = () => {
    const { login } = useAuth();
    const { remoteSessionExpired } = useSelector(customApiSelectors);
    const dispatch = useDispatch();
    const classes = useStyles();

    const handleLogin = () => {
        storeReferrer();
        dispatch(setRemoteSessionExpired(false));
        login();
    };
    return (
        <Modal open={remoteSessionExpired} className={classes.modal}>
            <Block className={classes.modalContent} padding="compact">
                <Heading
                    klpHeadingLevel="TWO"
                    paddingBottom="compact"
                    translation="auth.sessionTimeout"
                />

                <Typography translation="auth.sessionTimeoutLoginAgain" />
                <Box className={classes.button}>
                    <ActionButton
                        actionType="button"
                        onClick={handleLogin}
                        translation="general.close"
                    />
                </Box>
            </Block>
        </Modal>
    );
};
